<template lang="html">
	<div class="stock stock--single">
		<div class="stock__body" >
            <div class="stock__info" data-default-cursor>
                <a v-if="promoData[0].name" :href="promoData[0].url" class="stock__title" v-html="promoData[0].name"></a>
                <a v-if="promoData[0].text" :href="promoData[0].url" class="stock__text" v-html="promoData[0].text"></a>
            </div>
            <div v-if="promoData[0].imgSrc" class="stock__image" v-custom-cursor="'.custom-cursor'">
                <div class="custom-cursor"><span>Перейти</span></div>
                <img :src="promoData[0].imgSrc" loading="lazy"/>
                <a :href="promoData[0].url" class="block-link cursor-none"/>
            </div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'CatalogStock',
	components: {
	},
	props: {
		promoData: {
			type: Array,
			default: () => [],
		},
        singleView: {
            type: Boolean,
            default: false,
        }
	},
}

</script>
